import _ from 'lodash';

import {
  CciResult,
  CodeInvalidReason,
  CombinationResult,
  PtpResult,
} from '../../common/types/Codes';

export const getInvalidReason = (
  combinationResult: CombinationResult
): CodeInvalidReason | null => {
  switch (combinationResult.ptp_result) {
    case PtpResult.NoModifierNeeded:
      return null;
    case PtpResult.AllowedWithModifier:
      return {
        code: combinationResult.code_2,
        reason: 'Code combination requires a modifier',
      };
    case PtpResult.NotAllowed:
      return {
        code: combinationResult.code_2,
        reason: 'Code combination not allowed',
      };
  }
};

export const getInvalidComboReasons = (cciResult: CciResult) => {
  const { codes, results } = cciResult;
  if (_.isEmpty(codes)) return [];
  for (const code of codes) {
    const invalidReasons: CodeInvalidReason[] = [];
    for (const combinationResult of results) {
      if (combinationResult.code_1 === code.code) {
        const invalidReason = getInvalidReason(combinationResult);
        if (invalidReason) invalidReasons.push(invalidReason);
      }
    }
    code.reasons = invalidReasons;
  }
  return codes;
};
